// hooks/useTableFilters.ts
import { useState, useEffect } from 'react';

export function useTableFilters() {
  const [searchTerm, setSearchTerm] = useState('');
  const [courtSearch, setCourtSearch] = useState('');
  const [partySearch, setPartySearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  const [debouncedCourt, setDebouncedCourt] = useState(courtSearch);
  const [debouncedParty, setDebouncedParty] = useState(partySearch);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setDebouncedCourt(courtSearch);
      setDebouncedParty(partySearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, courtSearch, partySearch]);

  const handleClearFilters = () => {
    setSearchTerm('');
    setCourtSearch('');
    setPartySearch('');
    setSelectedStatus('');
    setSelectedDate('');
    setCurrentPage(1);
  };

  const hasActiveFilters = Boolean(
    searchTerm || courtSearch || partySearch || selectedStatus || selectedDate
  );

  return {
    searchTerm,
    setSearchTerm,
    courtSearch,
    setCourtSearch,
    partySearch,
    setPartySearch,
    selectedStatus,
    setSelectedStatus,
    selectedDate,
    setSelectedDate,
    currentPage,
    setCurrentPage,
    debouncedSearch,
    debouncedCourt,
    debouncedParty,
    handleClearFilters,
    hasActiveFilters,
  };
}